module.exports = __webpack_public_path__ + "img/congrats.f3e4816e.svg";